import { useState, useEffect } from "react";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { useDispatch, useSelector } from "react-redux";
import { clearStepStatusShareholder } from "../../../Redux/store/onboardingFormSlice";
import { useToast } from "../../../Utils/toastContext";
import { useNavigate, useLocation } from "react-router-dom";
import { clearApplicationTypeShareHolder } from "../../../Redux/store/accountTypeSlice";
import MindmapTree from "../../../Components/onboarding/onboarding-tree";
import FilePreview from "../../../Components/onboarding/file-preview";
import {
  setStepStatus,
  setRejectedFields,
} from "../../../Redux/store/onboardingFormSlice";
const ReviewSubmitCorporate = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const [showVisualLink, setShowVisualLink] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([
    {
      name: "ABC Company",
      type: "Corporate",
      children: [
        { name: "Ann", type: "Individual", children: [] },
        {
          name: "XYZ",
          type: "Corporate",
          children: [
            {
              name: "DEF",
              type: "Corporate",
              children: [
                {
                  name: "Emily Johanson",
                  type: "Individual",
                  children: [],
                },
                { name: "Dalia limited", type: "Corporate", children: [] },
                { name: "Noah", type: "Individual", children: [] },
              ],
            },
            { name: "Aron", type: "Individual", children: [] },
          ],
        },
        { name: "Carol", type: "Trust", children: [] },
      ],
    },
    {
      name: "You trust",
      type: "Trust",
      children: [
        {
          name: "Subsidiary A",
          type: "Corporate",
          children: [
            { name: "John Doe", type: "Individual", children: [] },
            { name: "Jane Smith", type: "Individual", children: [] },
          ],
        },
        { name: "olbolnius alpha", type: "Trust", children: [] },
      ],
    },
    {
      name: "John Doe",
      type: "Individual",
      children: [],
    },
  ]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("John");
  const [lastName, setLastName] = useState("Mayer");
  const [email, setEmail] = useState("mayer@gmail.com");
  const [otherActivity, setOtherActivity] = useState("");
  const [mobileNumber, setMobileNumber] = useState("+61 6 7898 7298");
  const [customerType, setCustomerType] = useState("+61 6 7898 7298");
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
  const [fullName, setFullName] = useState("John Mayer");
  const [formerNames, setFormerNames] = useState("John Mayer");
  const [toCurrencyText, setToCurrencyText] = useState("");
  const [source, setSource] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentAddress, setAgentAddress] = useState("");
  const [clientNo, setClientNo] = useState("CM0013189P");
  const [fileAttorney, setFileAttorney] = useState(null);
  const [businessNature, setBusinessNature] = useState(null);
  const [signatories, setSignatories] = useState([]);
  const [abn, setAbn] = useState("");
  const [businessActivity, setBusinessActivity] = useState("smaple text");
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState("testing 1 2 3");
  const [fileProof, setFileProof] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [accountTypeLabel, setAccountTypeLabel] = useState("Individual");
  const [preview, setPreview] = useState("/avatar.svg");
  const [stateText, setStateText] = useState("");
  const [transactionLevel, setTransactionLevel] = useState("");
  const [investmentAmount, setInvestmentAmount] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [recommendedBy, setRecommendedBy] = useState("");
  const [DoI, setDoI] = useState("");
  const [foreignRegistered, setForeignRegistered] = useState("");
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  const [foreignAddress, setForeignAddress] = useState("");
  const [EIN, setEIN] = useState("");
  const [acn, setAcn] = useState("");
  const [stockRegistered, setStockRegistered] = useState("");
  const [arbn, setArbn] = useState("");
  const [companySecretary, setCompanySecretary] = useState("");
  const [companyTypeText, setCompanyTypeText] = useState("");
  const [countryCodeText, setCountryCodeText] = useState("Australia");
  const [registeredAddress, setRegisteredAddress] = useState("");
  const [principalAddress, setPrincipalAddress] = useState("");
  const [stockExchangeText, setStockExchangeText] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [bankdata, setBankdata] = useState([]);
  const [fileArticle, setFileArticle] = useState(null);
  const [fileCompanyOrganisationalChart, setFileCompanyOrganisationalChart] =
    useState(null);
  const [fileAccountantCertificate, setFileAccountantCertificate] =
    useState(null);
  const [fileIncorporationCertificate, setFileIncorporationCertificate] =
    useState(null);
  const [fileCertificateOfIncumbency, setFileCertificateOfIncumbency] =
    useState(null);
  const [fileUboCertificate, setFileUboCertificate] = useState(null);
  const [thpDescription, setThpDescription] = useState("");
  const [ticketLink, setTicketLink] = useState("");
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [fileExtractDocument, setFileExtractDocument] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);
  const [fileShareholderCertificate, setFileShareholderCertificate] =
    useState(null);
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);
  const [fileTicket, setFileTicket] = useState(null);
  const [webLink, setWebLink] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [customDate, setCustomDate] = useState("");
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [limitDurationLabel, setLimitDurationLabel] = useState("Per Day");
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState(1);
  const [signatoryType, setSignatoryType] = useState(1);
  const [members, setMembers] = useState([]);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }
  const [layers, setLayers] = useState([]);
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [abnStatus, setAbnStatus] = useState("");
  const [ifApplicable, setIfApplicable] = useState("no");
  const [fileFinancialService, setFileFinancialService] = useState(null);
  const [jurisdiction, setJurisdiction] = useState("");
  const [stockexchangeLocation, setStockexchangeLocation] = useState("");
  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [hasLicense, setHasLicense] = useState("no");
  const [licenseNumber, setLicenseNumber] = useState("");
  const [isConfirmVerify, setIsConfirmVerify] = useState(false);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const withdrawApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/withdraw`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleWithdraw = async () => {
    let toastMessage = null;
    try {
      const response = await withdrawApplicationAPI();
      if (response.status == 200) {
        setIsConfirmWithdraw(false);
        navigate("/login");
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const mapApiLayersToUiLayers = (apiLayers = []) => {
    return apiLayers.map((layer) => {
      const hasTabs = Array.isArray(layer.tabs);

      // Case 1: entities-based layer (NO tabs)
      if (!hasTabs) {
        return {
          id: layer.layer_number, // ✅ stable key
          layerName: `Layer ${layer.layer_number}`,
          hasTabs: false,
          groups: [
            {
              parent: null,
              shareholders: (layer.entities || []).map((e) => ({
                id: e.id,
                name: e.name,
                type: e.shareholder_type?.id || "",
                shares: e.percentage_ownership,
                email: e.email,
                typeText: e.stakeholder_type?.name || "",
                userId: e.shareholder_user_id,
                errors: {},
              })),
            },
          ],
        };
      }

      // Case 2: tabs-based layer
      return {
        id: layer.layer_number, // ✅ stable key
        layerName: `Layer ${layer.layer_number}`,
        hasTabs: true,
        groups: layer.tabs.map((tab) => ({
          parent: {
            id: tab.parent_id,
            name: tab.parent_name,
          },
          shareholders: (tab.group?.shareholders || []).map((s) => ({
            id: s.id,
            name: s.name,
            type: s.shareholder_type?.id || "",
            shares: s.percentage_ownership,
            typeText: s.stakeholder_type?.name || "",
            email: s.email,
            userId: s.shareholder_user_id,
            errors: {},
          })),
        })),
      };
    });
  };

  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/corporate/review-n-submit/preview`,
      );

      if (response.status == 200) {
        //SignUp details
        setFirstName(response.data.open_account_information.first_name);
        setLastName(response.data.open_account_information.last_name);
        setEmail(response.data.open_account_information.email_address);
        setMobileNumber(
          response.data.open_account_information.country_code +
            response.data.open_account_information.mobile_number,
        );
        setCustomerType(response.data.open_account_information.account_type);

        //Corporate information
        setPreview(response.data.corporate_information.company_logo_url);
        setAccountTypeLabel(
          response.data.corporate_information.corporate_type.name,
        );
        setAccountType(response.data.corporate_information.corporate_type.id);
        setFullName(response.data.corporate_information.company_full_name);
        setFormerNames(
          response.data.corporate_information.former_trading_names,
        );
        setClientNo(response.data.corporate_information.client_id);
        setRecommendedBy(response.data.corporate_information.recommended_by);
        setBusinessNature(response.data.corporate_information.business_nature);
        setBusinessActivity(
          response.data.corporate_information.business_activities,
        );
        const date = new Date(
          response.data.corporate_information.date_of_incorporation,
        );
        const formattedDate = date.toLocaleDateString("en-GB");
        setDoI(formattedDate);
        setForeignRegistered(
          response.data.corporate_information.is_registered_foreign_body == true
            ? "yes"
            : "no",
        );
        setEIN(response.data.corporate_information.foreign_ein);
        setCompanyRegistrationNumber(
          response.data.corporate_information.foreign_registration_number,
        );
        if (response.data.corporate_information.corporate_type.id != 1) {
          setForeignAddress(
            response.data.corporate_information.country_of_formation_address
              .google_address,
          );
        }
        setCompanyTypeText(
          response.data.corporate_information.registered_by_asic_as,
        );
        setCountryCodeText(
          response.data.corporate_information.country_of_domicile,
        );
        setRegisteredAddress(
          response.data.corporate_information.registered_office_address
            .google_address,
        );
        setPrincipalAddress(
          response.data.corporate_information.principal_place_address
            .google_address,
        );
        setStateText(
          response.data.corporate_information.state_or_territory_in_aus,
        );
        setAbn(response.data.corporate_information.abn);
        setAcn(response.data.corporate_information.acn);
        setStockRegistered(
          response.data.corporate_information.is_listed_on_comparable_exchange
            ?.value == true
            ? "No"
            : "Yes",
        );
        setStockExchangeText(
          response.data.corporate_information.relevant_stock_exchange_id,
        );
        setArbn(response.data.corporate_information.arbn);
        setCompanySecretary(
          response.data.corporate_information.company_secretary_name,
        );
        setCompanyWebsite(response.data.corporate_information.company_website);
        setToCurrencyText(
          response.data.corporate_information.default_investment_currency,
        );
        setTransactionLevel(
          response.data.corporate_information.intended_transaction_behavior,
        );
        setSource(response.data.corporate_information.source_of_funds_origin);
        setInvestmentAmount(
          response.data.corporate_information.expected_investment_amount,
        );
        setAgentName(response.data.corporate_information.local_agent_full_name);

        if (response.data.corporate_information.local_agent_address) {
          setAgentAddress(
            response.data.corporate_information.local_agent_address
              .google_address,
          );
        }
        // Directors
        setSignatoryTypeLabel(
          response.data.directors_n_shareholders.signatory_type.name,
        );
        setSignatoryType(
          response.data.directors_n_shareholders.signatory_type?.id,
        );
        setSignatories(response.data.directors_n_shareholders?.signatories);
        setFileAttorney(
          response.data.directors_n_shareholders?.board_resolution_file,
        );
        setLimitDurationLabel(
          response.data.directors_n_shareholders?.transaction_limit_duration
            .name,
        );
        setminimumInvestment(
          response.data.directors_n_shareholders?.transaction_limit_amount,
        );
        setCustomDate(
          response.data.directors_n_shareholders?.transaction_limit_expiry,
        );
        setMembers(
          response.data.directors_n_shareholders.invitees.map((item) => ({
            firstName: item.first_name, // or Date.now() if you want local-only IDs
            lastName: item.last_name,
            countryCode: item.country_code, // 1 = Individual, 2 = Corporate, 3 = Trust
            mobile: item.mobile_number,
            email: item.email,
            managingMember: item.is_managing_member,
          })),
        );
        const uiLayers = mapApiLayersToUiLayers(
          response.data.directors_n_shareholders.shareholders.layers,
        );
        setLayers(uiLayers);
        dispatch(clearApplicationTypeShareHolder());
        // External Bank
        setBankdata(response.data.external_bank);

        //Cash account
        const existingAccount = response.data.cash_account.map((acc) => ({
          value: acc.currency.id,
          label: `${acc.currency.name}`,
        }));
        setAccounts(existingAccount);

        // Proof docs
        setIfApplicable(response.data.proof_document.has_prosecution);
        setDescription(response.data.proof_document.prosecution_description);
        setFileProof(response.data.proof_document.prosecution_document);
        setWebLink(response.data.proof_document.website_link);
        setAbnStatus(response.data.proof_document.abn_lookup_status);
        setFilePublicDocument(
          response.data.proof_document.company_public_document,
        );
        setFileExtractDocument(
          response.data.proof_document.asic_search_extract,
        );
        setFileAccountantCertificate(
          response.data.proof_document.accountant_certificate,
        );
        setFileCompanyOrganisationalChart(
          response.data.proof_document.company_organization_chart,
        );
        setFileIncorporationCertificate(
          response.data.proof_document.certificate_of_incorporation,
        );
        let companyCategory =
          response.data.corporate_information.corporate_type.id;
        let companyType =
          response.data.corporate_information.registered_by_asic_as.id;
        if (
          companyCategory != 1 ||
          (companyCategory == 1 && companyType == 2)
        ) {
          setTicketLink(response.data.proof_document.ticket_number);
          setFileTicket(response.data.proof_document.asx_document);
        }
        if (
          companyCategory == 2 ||
          (companyCategory == 3 && companyType == 2) ||
          (companyCategory == 1 && companyType == 1)
        ) {
          setFileCompanyRegistration(
            response.data.proof_document.registration_certificate,
          );
          setFileDisclosure(
            response.data.proof_document.beneficial_ownership_certificate,
          );
        }
        setFileShareholderCertificate(
          response.data.proof_document.shareholder_certificate,
        );
        if (companyCategory != 1) {
          setFileCertificateOfIncumbency(
            response.data.proof_document.certificate_of_incumbency,
          );
          setFileUboCertificate(response.data.proof_document.ubo_certificate);

          setFileArticle(response.data.proof_document.articles_of_association);
        }
        if (
          companyCategory == 1 ||
          (companyCategory == 3 && companyType == 1)
        ) {
          const proofDoc = response?.data?.proof_document;
          const hasAfsl = proofDoc?.has_afsl;

          if (hasAfsl) {
            setHasLicense(hasAfsl);
            setFileLicense(proofDoc?.regulator_license_document);
          }
          setFileThirdParty(response.data.proof_document.contract_document);
          setThpDescription(response.data.proof_document.contract_description);
        }
        if (
          companyCategory == 2 ||
          (companyCategory == 3 && companyType == 2)
        ) {
          setFileForeignRegistration(
            response.data.proof_document.foreign_registration_certificate,
          );
          setJurisdiction(response.data.proof_document.primary_jurisdiction);
          setStockexchangeLocation(
            response.data.proof_document.stock_exchange_location,
          );
          setFileFinancialService(response.data.proof_document.afsl_document);
          setFileActivityEvidence(
            response.data.proof_document.company_activities_evidence,
          );
          setFileAdviceStatement(
            response.data.proof_document.statement_of_advice,
          );
        }
        setIsDataAvailable(true);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setIsDataAvailable(true);
    } finally {
    }
  };
  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = true; // collapsed
    });
    setCollapsedLayers(newState);
  };

  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = false; // expanded
    });
    setCollapsedLayers(newState);
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/corporate/review-n-submit/submit`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: "success" };
        const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };

  useEffect(() => {
    getDetails();
  }, []);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[5].status == "IN_REVIEW" ||
            stepStatus[5].status == "COMPLETED") && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                Your application is{" "}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{" "}
              </span>
            </div>
          )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          {isDataAvailable && (
            <>
               <div className="bg-white border rounded-md p-4 mt-2">
                <div className="flex items-center border-colour-custom space-x-2 px-4">
                  <img
                    src="/profile-circle-black.svg"
                    alt="User Avatar"
                    className="h-6 w-6 mb-2"
                  />
                  <h1 className="text-xl font-medium mb-2">
                    Open Account Information
                  </h1>
                </div>

                <div className="bg-white">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 pt-4">
                      <label className="mb-1 text-sm text-labelColour">
                        First Name
                      </label>
                      <span className="break-words max-w-full">
                        {firstName}
                      </span>

                      <label className="mb-1 mt-4 text-sm text-labelColour">
                        Last Name
                      </label>
                      <span className="break-words max-w-full">{lastName}</span>
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col mx-4 lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label className="mb-1 text-sm text-labelColour">
                        Email
                      </label>
                      <span className="break-all whitespace-normal max-w-full">
                        {email}
                      </span>

                      <label className="mb-1 mt-4 text-sm text-labelColour">
                        Mobile Number
                      </label>
                      <span className="break-words max-w-full">
                        {mobileNumber}
                      </span>
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4">
                      <label className="mb-1 text-sm text-labelColour">
                        Customer Type
                      </label>
                      <span className="break-words max-w-full">
                        {customerType}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-between items-start border-colour-custom px-4">
                  {/* Left Section: Icon + Heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/briefcase.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">
                      Corporate Information
                    </h1>
                  </div>

                  {/* Right Section: Edit Button */}
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(1);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>

                <div className="bg-white pb-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                    <div className="flex flex-col px-4 pt-4">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Company Logo
                      </label>
                      <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                        <img
                          src={preview.presigned_url}
                          alt={`${fullName}`}
                          className="w-20 h-20 rounded-full object-cover"
                        />
                      </div>
                      <label
                        htmlFor="advisorRefNumber"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Advisor Ref No
                      </label>

                      <span>{refNumber}</span>
                      <label
                        htmlFor="companyCategory"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Company Category
                      </label>

                      <span>{accountTypeLabel}</span>

                      <label
                        htmlFor="fullName"
                        className="mb-1 mt-4 text-sm text-labelColour whitespace-normal words-break"
                      >
                        Full Name of the Company
                      </label>
                      <span>{fullName}</span>
                      <label
                        htmlFor="formerNames"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        All Other Business Name(s)
                      </label>
                      <span>{formerNames}</span>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      {" "}
                      {accountType != 1 && (
                        <>
                          {" "}
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Client ID
                          </label>
                          <span>{clientNo}</span>
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm mt-4 text-labelColour"
                          >
                            Recommended by
                          </label>
                          <span>{recommendedBy?.name}</span>
                        </>
                      )}
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm mt-4 text-labelColour"
                      >
                        Business Nature
                      </label>
                      <span>{businessNature?.name}</span>
                      <label
                        htmlFor="expectedAmount"
                        className="mt-4 mb-1 text-sm text-labelColour"
                      >
                        Business Activity
                      </label>
                      <span>{businessActivity.name}</span>
                      {businessActivity.id == 6 && (
                        <>
                          <label
                            htmlFor="expectedAmount"
                            className="mt-4 mb-1 text-sm text-labelColour"
                          >
                            Other Activity
                          </label>
                          <span>{otherActivity}</span>
                        </>
                      )}
                      <label
                        htmlFor="clientNo"
                        className="mb-1 text-sm mt-4 text-labelColour"
                      >
                        Company's Date of Incorporation
                      </label>
                      <span>{DoI}</span>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                      {accountType == 1 && (
                        <>
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Client No
                          </label>
                          <span>{clientNo}</span>
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm mt-4 text-labelColour"
                          >
                            Recommended by
                          </label>
                          <span>{recommendedBy}</span>
                        </>
                      )}
                      {accountType != 1 && (
                        <>
                          {" "}
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm text-labelColour whitespace-normal words-break"
                          >
                            Is the company registered by the relevant foreign
                            registration body?
                          </label>
                          <span>{foreignRegistered}</span>
                          {foreignRegistered === "yes" && (
                            <>
                              <label
                                htmlFor="clientNo"
                                className="mb-1 text-sm mt-4 text-labelColour"
                              >
                                Employer Identification Number (EIN)
                              </label>
                              <span>{EIN}</span>
                            </>
                          )}
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm mt-4 text-labelColour"
                          >
                            Company registration number
                          </label>
                          <span>{companyRegistrationNumber}</span>
                          <label
                            htmlFor="clientNo"
                            className="mb-1 text-sm mt-4 text-labelColour whitespace-normal words-break"
                          >
                            The address of the company in its country of
                            formation, incorporation or registration as
                            registered by the relevant foreign registration body
                          </label>
                          <span>{foreignAddress}</span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                    <div className="flex flex-col px-4 pt-4">
                      {(accountType == 1 || accountType == 2) && (
                        <>
                          <label
                            htmlFor="applicantCountry"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Registered by ASIC as
                          </label>
                          <span>{companyTypeText.name}</span>
                        </>
                      )}
                      {accountType == 3 && (
                        <>
                          <label
                            htmlFor="applicantCountry"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Type Of Company
                          </label>
                          <span>{companyTypeText}</span>
                          <label
                            htmlFor="applicantCountry"
                            className="mb-1 text-sm text-labelColour mt-4"
                          >
                            Company’s Domicile Country
                          </label>

                          <span>{countryCodeText}</span>
                        </>
                      )}
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour mt-4 whitespace-normal words-break"
                      >
                        Address of the Company's Registered Office
                      </label>

                      <span>{registeredAddress}</span>

                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour mt-4 whitespace-normal words-break"
                      >
                        Address of the Company's Principal place of business
                      </label>

                      <span>{principalAddress}</span>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      {accountType == 1 && (
                        <>
                          {" "}
                          <label
                            htmlFor="businessName"
                            className="mb-1 text-sm text-labelColour"
                          >
                            State or Territory in Australia
                          </label>
                          <span>{stateText?.name}</span>
                          <label
                            htmlFor="businessAddress"
                            className="mb-1 mt-4 text-sm text-labelColour"
                          >
                            ABN
                          </label>
                          <span>{abn}</span>
                          <label
                            htmlFor="businessAddress"
                            className="mb-1 mt-4 text-sm text-labelColour"
                          >
                            ACN
                          </label>
                          <span>{acn}</span>
                        </>
                      )}
                      {accountType == 3 && (
                        <>
                          {" "}
                          <label
                            htmlFor="businessName"
                            className="mb-1 text-sm text-labelColour whitespace-normal words-break"
                          >
                            Is your company listed under an Australian
                            Comparable Stock Exchange?
                          </label>
                          <span>{stockRegistered}</span>
                          {stockRegistered == "Yes" && (
                            <>
                              {" "}
                              <label
                                htmlFor="businessAddress"
                                className="mb-1 mt-4 text-sm text-labelColour"
                              >
                                Relevant Stock Exchange
                              </label>
                              <span>{stockExchangeText}</span>
                            </>
                          )}
                        </>
                      )}
                      {accountType != 1 && (
                        <>
                          {" "}
                          <label
                            htmlFor="businessName"
                            className="mb-1 text-sm text-labelColour"
                          >
                            ARBN
                          </label>
                          <span>{arbn}</span>
                        </>
                      )}
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour break-words"
                      >
                        The Name of the Company’s Secretary
                      </label>
                      <span>{companySecretary}</span>
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Company Website
                      </label>
                      <span>{companyWebsite}</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                    <div className="flex flex-col px-4 pt-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Default Investment Currency
                      </label>
                      <span>{toCurrencyText.name}</span>
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour whitespace-normal words-break"
                      >
                        Nature and level of the intended transaction behaviour
                      </label>

                      <span>{transactionLevel}</span>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label
                        htmlFor="businessName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Source of the funds including its origin
                      </label>
                      <span>{source}</span>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour break-words"
                      >
                        Expected Investment Amount
                      </label>
                      <span>{investmentAmount}</span>
                    </div>
                  </div>
                  {accountType != 1 && (
                    <>
                      <div className="flex items-center border-b border-colour-custom space-x-2 px-4 mt-4">
                        <h1 className="text-xl font-medium mb-2">
                          Details of the company's local agent in Australia (if
                          any)
                        </h1>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        <div className="flex flex-col px-4 pt-4">
                          <label
                            htmlFor="agentName"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Full Name
                          </label>
                          <span>{agentName}</span>
                        </div>
                        <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <label
                            htmlFor="applicantCountry"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Address
                          </label>

                          <span>{agentAddress}</span>
                        </div>
                        <div className="flex lg:pt-4 pt-0 flex-col pr-4"></div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="bg-white mt-4 border rounded-md p-4">
                <div className="border-b">
                  {/* Header */}
                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-colour-custom px-4 pb-2 mb-4 gap-2">
                    <div className="flex items-center gap-2">
                      <img
                        src="/people.svg"
                        alt="User Avatar"
                        className="h-6 w-6"
                      />
                      <h1 className="text-xl font-medium">
                        Directors:{" "}
                        <span className="text-[#8C8C8C] font-medium">
                          {firstName} {lastName}
                        </span>
                      </h1>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-1 sm:gap-2 items-start sm:items-center">
                      <span className="text-sm text-labelColour">
                        Number of directors within your organisation:
                      </span>
                      <span className="text-sm font-medium text-black">
                        <div className="font-semibold">
                          <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1  bg-white shadow-md">
                            {/* Count display */}
                            <span className="text-sm font-medium bg-gray-400 rounded-lg text-white p-2">
                              {members.length.toString().padStart(2, "0")}
                            </span>
                          </div>
                        </div>
                      </span>
                      <img
                        onClick={(e) => {
                          e.preventDefault();
                          setCurrentStep(2);
                        }}
                        src="/edit-details.svg"
                        alt="Edit Icon"
                        className="w-4 h-4 cursor-pointer"
                      />
                    </div>
                  </div>
                  {/* Directors Table */}
                  <div className="overflow-x-auto">
                    <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                      <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                        <tr>
                          <th className="p-2 w-[40px]"></th>
                          <th className="p-2">First Name</th>
                          <th className="p-2">Last Name</th>
                          <th className="p-2">Email Address</th>
                          <th className="p-2">Mobile Number</th>
                          <th className="p-2">Managing Member</th>
                        </tr>
                      </thead>
                      <tbody>
                        {members.map((member, idx) => (
                          <tr key={idx} className="border-t bg-white align-top">
                            <td className="p-2 font-medium text-labelColour">
                              {(idx + 1).toString().padStart(2, "0")}.
                            </td>
                            <td className="p-2 font-medium">
                              <span>{member.firstName}</span>
                            </td>
                            <td className="p-2 font-medium">
                              <span>{member.lastName}</span>
                            </td>
                            <td className="p-2 font-medium">
                              <span>{member.email}</span>
                            </td>
                            <td className="p-2 font-medium">
                              <span>
                                {member.countryCode} {member.mobile}
                              </span>
                            </td>
                            <td className="p-2 flex justify-center items-center">
                              <input
                                type="radio"
                                name="managingMember"
                                value={true}
                                checked={member.managingMember == true}
                                className="w-4 h-4 confirm-check-disabled border-gray-300 focus:ring-[#005a9c]"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Signatory Section */}
                  {members.length > 0 && (
                    <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                      {/* Signatory Type */}
                      <div className="flex flex-col px-2 pt-4">
                        <label
                          htmlFor="applicantCountry"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Signatory Type
                        </label>
                        <span>{signatoryTypeLabel}</span>
                      </div>

                      {/* Signatories */}
                      <div className="flex flex-col px-2 pt-4 border-t md:border-t-0 md:border-l border-gray-300">
                        <label
                          htmlFor="applicantCountry"
                          className="mb-1 text-sm text-labelColour"
                        >
                          Signatory/Signatories
                        </label>
                        <span>{signatories}</span>
                      </div>

                      {/* File Upload */}
                        <div className="flex flex-col px-2 pt-4">
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Board Resolution
                            </label>
                          </div>

                          {fileAttorney && (
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(fileAttorney);
                              }}
                              className="underline cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                            >
                              <div className="flex-col flex">
                                <span className="text-black">
                                  {fileAttorney.file_name}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                    </div>
                  )}
                  <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                    <h1 className="text-lg font-medium mb-2">
                      Transaction Limit
                    </h1>
                  </div>
                  <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* Signatory Type */}
                    <div className="flex flex-col px-2 pt-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Duration
                      </label>
                      <span>{limitDurationLabel}</span>
                    </div>
                    <div className="flex flex-col px-2 pt-4 md:border-r md:border-t-0 md:border-l border-gray-300">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Amount in Dollars ($)
                      </label>
                      <span>{minimumInvestment}</span>
                    </div>

                    <div className="flex flex-col px-2 pt-4">
                      <label
                        htmlFor="applicantCountry"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Transaction Limit Expiry Date{" "}
                      </label>
                      <span>
                        {customDate ? formatDate(customDate) : "Never"}
                      </span>
                    </div>
                  </div>
                </div>
                {companyTypeText.id == 1 && (
                  <div className="bg-white  rounded-md mt-4">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-2 md:space-y-0 px-2">
                      <div className="flex items-center space-x-2">
                        <img
                          src="/people.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-xl font-medium">
                          Shareholders:
                          <span className="text-xl font-medium text-[#8C8C8C] ml-1">
                            {firstName} {lastName}
                          </span>
                        </h1>
                      </div>
                      <div className="flex space-x-2">
                        <button
                          onClick={() => {
                            setShowVisualLink(true);
                          }}
                          className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                        >
                          <img
                            src="/hashtag.svg"
                            alt="Collapse Icon"
                            className="w-4 h-4 flex-shrink-0"
                          />
                          <span className="font-medium">Visual Link</span>
                        </button>
                        <button
                          onClick={handleCollapseAll}
                          className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                        >
                          <img
                            src="/arrow-square-up.svg"
                            alt="Collapse Icon"
                            className="w-4 h-4 flex-shrink-0"
                          />
                          <span className="font-medium">Collapse All</span>
                        </button>
                        <button
                          onClick={handleExpandAll}
                          className="bg-black text-white text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                        >
                          <img
                            src="/arrow-square-down.svg"
                            alt="Collapse Icon"
                            className="w-4 h-4 flex-shrink-0"
                          />
                          <span className="font-medium">Expand All</span>
                        </button>
                      </div>
                    </div>
                    {showVisualLink && (
                      <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[99999]">
                        <div className="relative bg-white rounded-2xl shadow-2xl w-[95%] md:w-[900px] p-6">
                          {/* Close Button */}
                          <button
                            onClick={() => setShowVisualLink(false)}
                            className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl font-bold transition-colors"
                          >
                            &times;
                          </button>

                          {/* Graph */}
                          <div className="mt-6 w-full h-[500px] border border-gray-200 rounded-xl overflow-hidden">
                            <MindmapTree data={data} />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="pt-2">
                      {layers.map((layer) => (
                        <ShareholderLayer
                          key={layer.id}
                          layer={layer}
                          collapsed={collapsedLayers[layer.id] ?? false}
                          onToggle={() =>
                            setCollapsedLayers((prev) => ({
                              ...prev,
                              [layer.id]: !prev[layer.id],
                            }))
                          }
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-between items-start border-colour-custom px-4">
                  {/* Left Section: Icon + Heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/cards.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">
                      Connect External Account
                    </h1>
                  </div>

                  {/* Right Section: Edit Button */}
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(3);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
                {bankdata.map((bank, index) => (
                  <div className="relative flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 mb-6 border rounded-md">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full pr-6">
                      {/* Column 1 */}
                      <div className="flex flex-col md:px-4 md:pt-6">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-labelColour"
                        >
                          {index + 1}. Account Holder Name
                        </label>
                        <span className="text-sm">{bank.account_name}</span>
                        <div className="mt-4">
                          <label
                            htmlFor="investmentType"
                            className="mb-1 text-xs text-labelColour"
                          >
                            Account Number or IBAN
                          </label>
                          <div className="text-sm">{bank.account_number}</div>
                        </div>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs"
                        >
                          <span className="text-labelColour">Swift Code</span>
                        </label>
                        <div className="text-sm">{bank.swift_code}</div>
                        <div className="flex flex-row gap-2 mt-2 mb-2">
                          {bank.isVerified && (
                            <>
                              <button className="bg-white border-[#75E380] border-2 text-[#75E380] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                                <img
                                  src="/valid.svg"
                                  alt="Camera Icon"
                                  className="w-4 h-4"
                                />
                                Verified
                              </button>
                            </>
                          )}
                          {bank.status == "onboarding" && (
                            <>
                              <button className="bg-white border-[#FF5050] border-2 text-[#FF5050] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                                <img
                                  src="/danger.svg"
                                  alt="Camera Icon"
                                  className="w-4 h-4"
                                />
                                Unverified
                              </button>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Column 2 */}
                      <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 text-xs text-labelColour"
                        >
                          Branch Identifier{" "}
                        </label>
                        <span className="text-sm">
                          {bank.branch_identifier.name}
                        </span>
                        {bank.branch_identifier.id == 1 && (
                          <>
                            <label
                              htmlFor="investmentManagerFees"
                              className="mb-1  mt-4  text-xs text-labelColour"
                            >
                              BSB
                            </label>
                            <span className="text-sm">{bank.account_bsb}</span>
                          </>
                        )}
                        {bank.branch_identifier.id == 2 && (
                          <>
                            <label
                              htmlFor="investmentManagerFees"
                              className="mb-1 mt-4 text-xs text-labelColour"
                            >
                              Country{" "}
                            </label>
                            <span className="text-sm">{bank.country_code}</span>
                            {bank.country_code == "CA" && (
                              <>
                                {" "}
                                <label
                                  htmlFor="investmentManagerFees"
                                  className="mb-1 mt-4 text-xs text-labelColour"
                                >
                                  Financial Institution Identifier{" "}
                                </label>
                                <span className="text-sm">
                                  {bank.institution_number}
                                </span>
                                <label
                                  htmlFor="investmentManagerFees"
                                  className="mb-1 mt-4 text-xs text-labelColour"
                                >
                                  Transit Number
                                </label>
                                <span className="text-sm">
                                  {bank.transit_number}
                                </span>
                              </>
                            )}
                          </>
                        )}
                        {bank.branch_identifier.id == 3 && (
                          <>
                            <label
                              htmlFor="investmentManagerFees"
                              className="mb-1 mt-4 text-xs text-labelColour"
                            >
                              Routing Number{" "}
                            </label>
                            <span className="text-sm">
                              {bank.routing_number}
                            </span>
                          </>
                        )}
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Active{" "}
                        </label>
                        <span className="text-sm">
                          {bank.is_active == true ? "Yes" : "No"}
                        </span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Default{" "}
                        </label>
                        <span className="text-sm">
                          {bank.is_default == true ? "Yes" : "No"}
                        </span>
                        {/* <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Payment Method{" "}
                        </label>
                        <span className="text-sm">{bank.paymentMethod}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          ACH Code{" "}
                        </label>
                        <span className="text-sm">{bank.achCode}</span> */}
                      </div>

                      {/* Column 3 */}
                      <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 text-xs"
                        >
                          <span className="text-labelColour">Currency</span>
                        </label>
                        <div className="text-sm">{bank.currency.name}</div>
                        <div className="mb-2 mt-4">
                          <label
                            htmlFor="investmentType"
                            className="mb-1 text-xs text-labelColour"
                          >
                            Uploaded Docs
                          </label>
                          {bank.proof_image && (
                            <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(bank.proof_image);
                                }}
                                className="flex-col flex "
                              >
                                <span className="text-black break-all cursor-pointer underline">
                                  {bank.proof_image.file_name}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                        <div className="">
                          <label
                            htmlFor="investmentType"
                            className="mb-1 text-xs text-labelColour"
                          >
                            Address
                          </label>
                          <div className="text-sm">
                            {bank.address_line1 != null
                              ? bank.address_line1
                              : ""}
                          </div>
                          <div className="text-sm">
                            {bank.address_line2 != null
                              ? bank.address_line2
                              : ""}
                          </div>
                          <div className="text-sm">
                            {bank.address_line3 != null
                              ? bank.address_line3
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {isModalOpen && currentDocument && (
                  <DocumentPreview
                    fileUrl={currentDocument.presigned_url}
                    fileName={currentDocument.file_name}
                    onClose={() => setIsModalOpen(false)}
                  />
                )}
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex flex-col md:flex-row md:items-center justify-between border-colour-custom px-4 py-2 gap-2">
                  {/* Left Section */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/money-2.svg"
                      alt="Cash Icon"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">
                      Cash Account Information
                    </h1>
                  </div>

                  {/* Right Section - Responsive */}
                  <div className="flex items-center justify-start md:justify-end gap-x-2 flex-wrap">
                    <div className="flex flex-col items-start md:items-end">
                      <span className="text-sm font-semibold text-[#464646] leading-tight">
                        No. Of Cash Account
                      </span>
                    </div>
                    <span className="text-md font-semibold hidden md:inline">
                      |
                    </span>
                    <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#34C046]">
                      {String(accounts.length).padStart(2, "0")}
                    </span>

                    <img
                      onClick={(e) => {
                        e.preventDefault();
                        setCurrentStep(4);
                      }}
                      src="/edit-details.svg"
                      alt="Edit Icon"
                      className="w-4 h-4 cursor-pointer"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {Array.from({ length: accounts.length }).map((_, index) => (
                    <div key={index} className="px-4 py-2">
                      <label
                        htmlFor="advisorRefNumber"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Account No.{String(index + 1).padStart(2, "0")}
                      </label>
                      <span className="text-sm">{accounts[index].label}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-between items-start border-colour-custom px-4">
                  {/* Left Section: Icon + Heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/note-2.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">
                      Upload Proof Documents
                    </h1>
                  </div>

                  {/* Right Section: Edit Button */}
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(5);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b pb-2">
                  {/* first column */}
                  <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                    {(accountType != 1 ||
                      (accountType == 1 && companyTypeText.id == 2)) && (
                      <>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            A search/extract of the relevant Australian stock
                            exchange
                          </label>
                        </div>
                        {ticketLink != "" && (
                          <>
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Ticket Number
                            </label>
                            <span>{ticketLink}</span>
                          </>
                        )}
                        {fileTicket && (
                          <>
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Uploaded File
                            </label>
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(fileTicket);
                              }}
                              className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                            >
                              <div className="flex-col flex">
                                <span className="text-black">
                                  {fileTicket.file_name}
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="mt-4">
                          <FilePreview
                            label="A public document issued by the company (E.g. Annual
                            General Report)"
                            file={filePublicDocument}
                            onClick={handleFileClick}
                          />
                        </div>
                      </>
                    )}
                    {(accountType == 2 ||
                      (accountType == 3 && companyTypeText.id == 2) ||
                      (accountType == 1 && companyTypeText.id == 1)) && (
                      <>
                        <div className="mt-4">
                          <FilePreview
                            label={
                              accountType == 2
                                ? "Valid Company Registration Certificate issued by ASIC"
                                : "Valid Company Registration Certificate"
                            }
                            file={fileCompanyRegistration}
                            onClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FilePreview
                            label="Disclosure certificate verifying information about the
                      beneficial ownership of the company"
                            file={fileDisclosure}
                            onClick={handleFileClick}
                          />
                        </div>
                      </>
                    )}
                    <div className="mt-4">
                      <FilePreview
                        label="Shareholder Certificate"
                        file={fileShareholderCertificate}
                        onClick={handleFileClick}
                      />
                    </div>
                    <div className="mt-4">
                      <FilePreview
                        label="A search/extract of the relevant ASIC database"
                        file={fileExtractDocument}
                        onClick={handleFileClick}
                      />
                    </div>
                    {accountType != 1 && (
                      <div className="mt-4">
                        <FilePreview
                          label="Certificate of Incumbency"
                          file={fileCertificateOfIncumbency}
                          onClick={handleFileClick}
                        />
                      </div>
                    )}
                  </div>
                  {/* second column */}
                  <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                    {(accountType == 1 ||
                      (accountType == 3 && accountType == 1)) && (
                      <>
                        {" "}
                        <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                          <label
                            htmlFor="investmentType"
                            className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center"
                          >
                            Does your company possess a financial services
                            license?
                          </label>
                          <div className="flex items-center gap-4 opacity-50 ">
                            <label className="flex items-center text-sm text-black">
                              <input
                                type="radio"
                                name="hasLicense"
                                value={true}
                                checked={hasLicense === true}
                                disabled={true}
                                className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                              />
                              <span className="ml-2">Yes</span>
                            </label>
                            <label className="flex items-center text-sm text-black">
                              <input
                                type="radio"
                                name="hasLicense"
                                value={false}
                                checked={hasLicense === false}
                                disabled={false}
                                className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                              />
                              <span className="ml-2">No</span>
                            </label>
                          </div>
                          {hasLicense && (
                            <>
                              <label
                                htmlFor="firstName"
                                className="mb-1 mt-4 text-sm text-labelColour"
                              >
                                Licence Number
                              </label>
                              <span>{licenseNumber}</span>
                              <div className="mt-4">
                                <FilePreview
                                  label="Upload a search of the license or other
                                  records of the relevant commonwealth, state,
                                  or Territory regulator"
                                  file={fileLicense}
                                  onClick={handleFileClick}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    )}
                    {(accountType == 2 ||
                      (accountType == 3 && accountType == 2)) && (
                      <>
                        <div className="mt-4">
                          <FilePreview
                            label="Valid company registration certificate issued by the
                            relevant foreign registration body"
                            file={fileForeignRegistration}
                            onClick={handleFileClick}
                          />
                        </div>
                        <label
                          htmlFor="firstName"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Jurisdiction of the primary operations of the company
                        </label>
                        <span>{jurisdiction}</span>
                        <div className="mt-4">
                          <FilePreview
                            label="Valid Australian financial services license issued
                            by ASIC"
                            file={fileFinancialService}
                            onClick={handleFileClick}
                          />
                        </div>
                      </>
                    )}
                    <label
                      htmlFor="investmentType"
                      className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center mt-4"
                    >
                      If applicable, description and proof of any current or
                      recent prosecutions and inquiries related to money
                      laundering, terrorist links, tax offenses, and
                      corruption{" "}
                    </label>
                    <div className="flex items-center gap-4 opacity-50 ">
                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="signatory"
                          value={true}
                          checked={ifApplicable === true}
                          disabled={true}
                          className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                        />
                        <span className="ml-2">Yes</span>
                      </label>
                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="signatory"
                          value={false}
                          checked={ifApplicable === false}
                          disabled={false}
                          className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                        />
                        <span className="ml-2">No</span>
                      </label>
                    </div>
                    {ifApplicable && (
                      <>
                        <div className="mt-4">
                          <label
                            htmlFor="description"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Description
                          </label>
                          <span>{description}</span>
                        </div>
                        <div className="mt-4">
                          <FilePreview
                            label="Upload Proof"
                            file={fileProof}
                            onClick={handleFileClick}
                          />
                        </div>
                        {accountType != 1 && (
                          <div className="mt-4">
                            <FilePreview
                              label="UBO Certificate"
                              file={fileUboCertificate}
                              onClick={handleFileClick}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  {/* third column */}
                  <div className="flex flex-col pr-4 pt-4">
                    <div className="">
                      <label
                        htmlFor="description"
                        className="mb-1 text-sm text-labelColour"
                      >
                        ABN
                      </label>
                      <span>{abn}</span>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="description"
                        className="mb-1 text-sm text-labelColour"
                      >
                        ABN Status
                      </label>
                      <span>{abnStatus}</span>
                    </div>
                    {(accountType == 1 ||
                      (accountType == 3 && accountType == 1)) && (
                      <>
                        <div className="mt-4">
                          <FilePreview
                            label="Contracts with third parties to verify the intended
                            transaction"
                            file={fileThirdParty}
                            onClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <label
                            htmlFor="description"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Description
                          </label>
                          <span>{thpDescription}</span>
                        </div>
                      </>
                    )}
                    {(accountType == 2 ||
                      (accountType == 3 && accountType == 2)) && (
                      <>
                        <div className="mt-4">
                          <FilePreview
                            label="Evidence about the activities undertaken by the
                            company"
                            file={fileActivityEvidence}
                            onClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FilePreview
                            label="Statement of Advise"
                            file={fileAdviceStatement}
                            onClick={handleFileClick}
                          />
                        </div>
                      </>
                    )}
                    <div className="mt-4">
                      <label
                        htmlFor="description"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Website Link
                      </label>
                      <span>{webLink}</span>
                    </div>
                    <div className="mt-4">
                      <FilePreview
                        label="Accountant Certificate"
                        file={fileAccountantCertificate}
                        onClick={handleFileClick}
                      />
                    </div>
                    <div className="mt-4">
                      <FilePreview
                        label="Certificate of incorporation"
                        file={fileIncorporationCertificate}
                        onClick={handleFileClick}
                      />
                    </div>
                    <div className="mt-4">
                      <FilePreview
                        label="Company Organisational Chart"
                        file={fileCompanyOrganisationalChart}
                        onClick={handleFileClick}
                      />
                    </div>
                    {accountType != 1 && (
                      <div className="mt-4">
                        <FilePreview
                          label="Articles of Association/Constitution"
                          file={fileArticle}
                          onClick={handleFileClick}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {stepStatus[5] &&
        stepStatus[5].status !== "COMPLETED" &&
        stepStatus[5].status !== "APPROVED" &&
        stepStatus[2].status !== "IN_REVIEW" && (
          <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              {/* Save as Draft */}
              <button
                onClick={() => {
                  setIsConfirmWithdraw(true);
                }}
                className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Withdraw Application</span>
              </button>

              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleSubmit();
                }}
                className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Submit</span>
              </button>
            </div>
          </footer>
        )}
      {isConfirmWithdraw && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">
              Are you sure you want to Withdraw Application?
            </h2>
            <p class="text-sm text-black mb-4">
              This will delete all details entered during registration. None of
              the details entered in this form will be saved.
            </p>

            <div class="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                }}
                class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleWithdraw();
                }}
                class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {isConfirmSubmit && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/tick-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">Hi John!</h2>
            <h2 class="text-md font-medium mb-2">
              Individual Application Form has been Submitted Successfully{" "}
            </h2>
            <p class="text-sm text-black mb-4">
              Caprock team will evaluate your application and get back to you
              shortly.
            </p>
            <p class="text-sm text-black mb-4">Thank You. </p>
          </div>
        </div>
      )}
    </div>
  );
};

const ShareholderLayer = ({ layer, collapsed, onToggle }) => {
  const { layerName, groups, hasTabs } = layer;
  const isOpen = !collapsed;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(0);
  const rowsToRender = hasTabs
    ? groups[activeTab]?.shareholders || []
    : groups[0]?.shareholders || [];
  const calculateSharesCounter = (list) =>
    list.reduce((acc, s) => acc + Number(s.shares || 0), 0).toFixed(2);

  useEffect(() => {
    setActiveTab(0);
  }, [groups]);

  const currentRows = groups[activeTab]?.shareholders || [];

  return (
    <div className="border rounded-2xl shadow-sm bg-white mb-6">
      {/* Header */}
      <div
        onClick={onToggle}
        className="bg-[#464646] text-white px-4 py-2 rounded-t-2xl flex justify-between items-center cursor-pointer"
      >
        <h2 className="text-sm font-medium">{layerName}</h2>
        <span className="text-lg">{isOpen ? "−" : "+"}</span>
      </div>

      {isOpen && (
        <>
          {/* Tabs ONLY when groups > 1 */}
          {hasTabs && (
            <div className="flex border-b">
              {groups.map((g, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`px-4 py-2 text-sm font-medium ${
                    activeTab === idx
                      ? "bg-black text-white"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {g.parent?.name}
                </button>
              ))}
            </div>
          )}

          {/* Table */}
          <div className="p-4 border rounded-b-lg">
            <div className="overflow-x-auto">
              <table className="w-full text-sm  text-[#8C8C8C]">
                <thead>
                  <tr className="border">
                    <th className="p-2"></th>
                    <th className="p-2 text-left font-medium">
                      Shareholder Name
                    </th>
                    <th className="p-2 text-left font-medium">Type</th>
                    <th className="p-2 text-left font-medium">Shares</th>
                    <th className="p-2 text-left font-medium">Email</th>
                    <th className="p-2 text-left font-medium">
                      User Registration
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rowsToRender.map((s, idx) => (
                    <tr key={s.id} className="border-t font-medium text-black">
                      <td className="p-2 text-[#8C8C8C]">
                        {String(idx + 1).padStart(2, "0")}.
                      </td>
                      <td className="p-2">{s.name}</td>
                      <td className="p-2">{s.typeText}</td>
                      <td className="p-2">{s.shares}</td>
                      <td className="p-2">{s.email}</td>
                      <td className="p-2">
                        {s.shares >= 25 ? (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              let redirectState = {
                                path: `/onboarding-shareholder/${s.userId}/${s.type}/shareholder/${false}`,
                                state: {
                                  from: location.pathname,
                                },
                              };
                              sessionStorage.setItem(
                                "redirectAfterLogin",
                                JSON.stringify(redirectState),
                              );
                              navigate(
                                `/onboarding-shareholder/${s.userId}/${s.type}/shareholder/${false}`,
                                {
                                  state: {
                                    from: location.pathname,
                                  },
                                },
                              );
                            }}
                            className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium"
                          >
                            View Application
                          </button>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ReviewSubmitCorporate;
